import {
  Text,
  TextSize,
  TextWeight,
  makeStyles
} from '@focaldata/cin-ui-components'
import { WaveFlowBreadcrumb } from './WaveFlowBreadcrumb'

const useStyles = makeStyles()({
  page: { padding: '24px 32px' },
  empty: { marginTop: 12, color: '#6B7280' }
})

/** A step with no screen yet, navigable so the flow's shape stays visible. */
export const WaveStepPlaceholder = ({ step }: { step: string }) => {
  const { classes } = useStyles()

  return (
    <div>
      <WaveFlowBreadcrumb activeStep={step} />

      <div className={classes.page}>
        <Text size={TextSize.xl} weight={TextWeight.Bold}>
          {step}
        </Text>
        <div className={classes.empty}>
          <Text size={TextSize.ms}>Nothing here yet.</Text>
        </div>
      </div>
    </div>
  )
}
